module.exports = __webpack_public_path__ + "static/media/sort.5364a5fc.svg";